import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCustomerBlockStatus } from '../../services/customers';
import { getCustomerScheduleBlockWarning } from '../../helpers/customers/customerScheduleBlockWarning';

function useCustomerScheduleBlockWarning({
  customerId,
  businessId,
  employeeId,
}: {
  customerId?: string | null;
  businessId?: string | null;
  employeeId?: string | null;
}) {
  const enabled = !!customerId && !!businessId;

  const { data, isLoading } = useQuery({
    queryKey: ['customer-schedule-block', customerId, businessId],
    queryFn: () => getCustomerBlockStatus(customerId!, businessId!),
    enabled,
    staleTime: 30_000,
    // Opt out of the global keepPreviousData so a cleared or swapped customer
    // doesn't keep showing the previous customer's block status
    placeholderData: undefined,
  });

  const warning = useMemo(
    () => (data ? getCustomerScheduleBlockWarning(data, employeeId) : null),
    [data, employeeId],
  );

  return {
    warning,
    isLoading: enabled && isLoading,
  };
}

export default useCustomerScheduleBlockWarning;
